<template>
  <div class="content-body customers-wrapper transaction-history">
    <b-row>
      <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
        <div class="filter-wrapper">
          <b-input-group prepend>
            <b-form-input @keyup.native="search(true)" placeholder="Search" v-model="searchString"></b-form-input>
            <b-dropdown text="Advanced" variant="primary" slot="append">
              <b-dropdown-item
                v-for="searchField in searchableFields"
                :key="searchField.value"
                @click="searchOption(searchField.value)"
              >
                {{ searchField.text }}
                <i
                  v-if="selectedSearchOption === searchField.value"
                  class="ml-1"
                >
                  <img
                    width="15"
                    height="15"
                    src="@/assets/images/checked-symbol.svg"
                    alt
                    class="mr-1"
                    style="margin-top: -2px; margin-right: 0px;"
                  />
                </i>
              </b-dropdown-item>
            </b-dropdown>
          </b-input-group>
        </div>
      </b-col>
    </b-row>
    <div class="mt-3">
      <div class="data-container">
        <b-table
          show-empty
          :fields="racksCustomColumns"
          :current-page="currentPage"
          responsive
          :items="isSearchType ? [] : customHistories"
          :empty-text="(loading) ? 'Loading data' : emptyText"
        ></b-table>
      </div>
    </div>
    <div>
      <b-row>
        <b-col>
          <div class="mt-1">
            <span
              class="pagination-indicator"
            >Showing {{ currentFirstItem }} to {{ currentLastItem }} of {{ maxPage }} pages</span>
          </div>
        </b-col>
        <b-col>
          <b-pagination
            hide-goto-end-buttons
            align="right"
            size="md"
            :total-rows="(totalPerPage > 0 ) ? maxPage * totalPerPage : 1"
            :limit="(totalPerPage > 0 ) ? 5 : 1"
            :per-page="totalPerPage"
            @change="paginate"
            class="custom-pagination"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import "../../plugins/vue-currency-filter";
import Datepicker from "vue-bulma-datepicker";
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "transaction-history",
  components: {
    Datepicker
  },
  data() {
    return {
      searchableFields: [
        { value: "membership_id", text: "Membership ID" },
      ],
      emptyText: "No Records Found",
      isSearchType: false,
      searchString: "",
      selectedSearchOption: "membership_id",
      searchPayload: {
        card_number: ""
      }
    };
  },
  computed: {
    ...mapState("transactions", [
      "loading",
      "customHistories",
      "racksCustomColumns",
      "currentFirstItem",
      "currentLastItem",
      "nextPage",
      "prevPage",
      "maxPage",
      "currentPage",
      "totalPerPage"
    ])
  },
  created() {
    this.initPage();
  },
  methods: {
    async initPage() {
      await this.getRacksCustomColumns();
      await this.getCustomHistory(1);
    },
    async getRacksCustomColumns() {
      this.$store.dispatch("transactions/getRacksCustomColumns");
    },
    async getCustomHistory(page) {
      let param = {
        page: page,
        payload: this.searchPayload
      };
      await this.$store.dispatch("transactions/getCustomHistory", param);
    },
    paginate(page) {
      //   if (this.searching) {
      //     return this.search(false, page);
      //   }

      return this.getCustomHistory(page);
    },
    search(newSearch = false, page) {
      let param = {
        payload: {
          card_number: this.searchString
        },
        page: newSearch === true ? 1 : page
      };

      if (this.searchString.trim() === "") {
        return this.getCustomHistory(1);
      }
      if (newSearch) {
        this.emptyText = "Searching...";
        this.isSearchType = true;
      }
      let _this = this;
      this.$store.dispatch("transactions/getCustomHistory", param).then(() => {
        _this.emptyText = 'No Records Found for "' + _this.searchString + '"';
        _this.isSearchType = false;
      });
    },
  }
};
</script>